<template>
    <div class="profile__table__box table-responsive">
        <table id="vehicles__table" class="profile__table table" cellpadding="0" cellmargin="0" width="100%">
            <thead>
                <tr>
                    <th>Nº Orden</th>
                    <th>Taller</th>
                    <th>Fecha</th>
                    <th>Subtotal</th>
                    <th>IGV</th>
                    <th>Total</th>
                    <th>Valoración</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="element in list" :key="element.id">
                    <td class="text-center">{{ element.order_number }}</td>
                    <td class="text-center">{{ element.garage_name }}</td>
                    <td class="text-center">{{ element.schedule_date }}</td>
                    <td class="text-right">S/ {{ element.subtotal }}</td>
                    <td class="text-right">S/ {{ element.taxes }}</td>
                    <td class="text-right">S/ {{ element.total }}</td>
                    <td class="text-center" v-if="element.rating">{{ element.rating }}</td>
                    <td class="text-center" v-else>
                        <a
                            href="#"
                            class="btn btn--green evaluation"
                            @click.prevent="openModal(element.id, element.order_number)"
                        >
                            Valorar
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <add-evaluation-form
        :url_detail="url_detail"
        :url_store="url_store"
        :order_header_id="order_header_id ?? ''"
        :order_number="order_number ?? ''"
        @close-modal="closeModal()"
        @refresh-table="getList()"
    ></add-evaluation-form>
</template>

<script>
import { inject, provide, ref } from 'vue';
import { customAlert } from '../../../general/js/utils/swalMessages';

export default {
    props: {
        url_list: {
            type: String,
            default: '',
        },
        url_detail: {
            type: String,
            default: '',
        },
        url_store: {
            type: String,
            default: '',
        },
    },
    setup (props) {
        const loading = inject("loading");

        const order_header_id = ref('');
        const order_number = ref('');
        const list = ref([]);

        const getList = async () => {
            try {
                const { data } = await axios.request({
                    url: props.url_list,
                    method: 'POST',
                });

                list.value = data;
            } catch (error) {
                console.error(error);
            }
        }
        getList();

        const openModal = async (id, o_number) => {
            order_header_id.value = id;
            order_number.value = o_number;

            $("#addEvaluationModal").modal("show");
        };

        const closeModal = () => {
            order_header_id.value = '';
            order_number.value = '';
        }

        return {
            order_header_id,
            order_number,
            list,
            getList,
            openModal,
            closeModal,
        }
    }
}
</script>
